import services from "../services";

export const serviceLevelMonitoringActions = {
  recordData,
};

/** Thunk so dispatch(...) returns a Promise (success boolean). */
function recordData(monitoringData = {}) {
  return () =>
    services.serviceLevelMonitoringService.recordData(monitoringData);
}
